import type { LottieComponentProps } from "lottie-react";
import dynamic from "next/dynamic";

const Lottie = dynamic(() => import("lottie-react"), { ssr: false });

const LottieAnimation = (props: LottieComponentProps) => <Lottie {...props} />;

export default LottieAnimation;
